<div class="container">
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <div class="p-fluid formgrid grid">
          <div class="col-12 md:col-6 lg:col-4 mb-3">
            <label>{{ 'UnallocatedContainer.DONumber' | translate }}</label>
            <p-chips (onAdd)="doNoChipsAdd($event)" separator="," [(ngModel)]="searchParams.doNos">
            </p-chips>
          </div>
        </div>
        <div class="grid">
          <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
          </div>
      </div>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
        <laas-data-table [expandable]="true" (rowExpanded)="searchDetailClick($event)" [tableKey]="preferenceKey"
        [dataKey]="'seqNo'" [value]="searchResults" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
            <laas-data-table [tableTitle]="formatTableTitle(rowData)" [tableKey]="preferenceKey2"
            [value]="rowData.details" [defaultColumns]="detailColumns" [paginator]="false" [style]="{ 'overflow-y': 'auto' }">

              <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
                <td *ngFor="let col of columns">
                  <ng-container [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'doStatus'">
                      <div class="overflow-text">
                        {{ rowData[col.field] | optionsMapping:doStatusOptions | replaceNullWith:'-' }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div [ngSwitch]="col.dataType">
                        <ng-container *ngSwitchCase="'date'">
                          <div class="overflow-text">
                            {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'number'">
                          <div class="overflow-text">
                            {{ rowData[col.field] | number:'1.0':'en-US'}}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <div class="overflow-text">
                            {{ rowData[col.field] | replaceNullWith:'-'}}
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </td>
              </ng-template>
            </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
